'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.objectValueOrDefault = exports.isObjectEqual = void 0;
function isObjectEqual(a, b) {
    if (!a || !b) {
        return a === b;
    }
    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) {
        return false;
    }
    return aKeys.every(function (key) {
        var aVal = a[key];
        var bVal = b[key];
        if (typeof aVal === 'object' && typeof bVal === 'object') {
            return isObjectEqual(aVal, bVal);
        }
        return aVal === bVal;
    });
}
exports.isObjectEqual = isObjectEqual;
/**
 * Gets the value defined by 'key' or the 'DEFAULT' value if undefined.
 * @param obj
 * @param key
 */
function objectValueOrDefault(obj, key) {
    if (!key) {
        return obj.DEFAULT;
    }
    var result = obj[key];
    if (result !== undefined) {
        return result;
    }
    return obj.DEFAULT;
}
exports.objectValueOrDefault = objectValueOrDefault;
